import styled from 'styled-components';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { verticalSpace } from '@doltech/utils/lib/css-style';
import * as React from 'react';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { ButtonSize } from '@doltech/ui/lib/figma/Button/ButtonSize/ButtonSize';
import { ButtonContentGeneral } from '@doltech/ui/lib/figma/Button/ButtonContentGeneral/ButtonContentGeneral';
import { ButtonStyles } from '@doltech/ui/lib/figma/Button/ButtonStyles/ButtonStyles';
import { isEmpty } from 'lodash';

const Container = styled.aside`
  ${verticalSpace(20)};
`;

const SectionBlogTitle = styled.div`
  display: grid;
  grid-template-columns: max-content auto;
  gap: 8px;
`;

const Line = styled.div`
  height: 16px;
  width: auto;
  border-bottom: solid 1px ${colorsV2.purple100};
`;

const ListCardBlog = styled.div`
  ${verticalSpace(32)};
`;
const Action = styled.div`
  display: flex;
  justify-content: center;

  .button {
    width: max-content;
  }
`;

interface SectionGrammarRelatedProps {
  title?: string;
  data?: any[];
  renderData?: (item: any) => React.ReactNode;
  hasButton?: boolean;
  buttonLabel?: string;
  lessonListUrl?: string;
  loading?: boolean;
}

export const SectionGrammarRelated = (props: SectionGrammarRelatedProps) => {
  const { title, data, renderData, hasButton, buttonLabel, lessonListUrl } = props;
  if (isEmpty(data)) {
    return null;
  }

  return (
    <Container>
      <SectionBlogTitle>
        <ResponsiveTypography.Title level={5} variant="semi-bold/20-32" color="purple100">
          {title}
        </ResponsiveTypography.Title>
        <Line/>
      </SectionBlogTitle>
      <ListCardBlog>
        {data?.map((item, index) => (
          <React.Fragment key={index}>
            {renderData(item)}
          </React.Fragment>
        ))}
      </ListCardBlog>
      {hasButton && (
        <Action>
          <a className="button" rel="noreferrer" href={lessonListUrl}>
            <ButtonStyles
              color="purple"
              colorStyle="bold"
              transparent={false}
              content={
                <ButtonSize
                  size="large"
                  verticalPadding
                  content={
                    <ButtonContentGeneral
                      text={buttonLabel}
                    />
                  }
                />
              }
            />
          </a>
        </Action>
      )}
    </Container>
  );
};
